import { p as proxyCustomElement, H, h } from './p-23afa4c1.js';
import { d as defineCustomElement$4 } from './p-eddedf58.js';
import { d as defineCustomElement$3 } from './p-8938db8f.js';
import { d as defineCustomElement$2 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';
import { h as hasNamedSlot } from './p-bde29a8a.js';

const cosmosStoryItemCss = ".cosmos-story-item{--cosmos-asset-item-base-gap:var(--cosmos-story-item-gap);--cosmos-asset-item-base-headline-color:var(--cosmos-story-item-headline-color);--cosmos-asset-item-base-headline-font-family:var(--cosmos-story-item-headline-font-family);--cosmos-asset-item-base-headline-font-size:var(--cosmos-story-item-headline-font-size);--cosmos-asset-item-base-headline-font-style:var(--cosmos-story-item-headline-font-style);--cosmos-asset-item-base-headline-font-weight:var(--cosmos-story-item-headline-font-weight);--cosmos-asset-item-base-headline-letter-spacing:var(--cosmos-story-item-headline-letter-spacing);--cosmos-asset-item-base-headline-line-height:var(--cosmos-story-item-headline-line-height);--cosmos-asset-item-base-headline-text-transform:var(--cosmos-story-item-headline-text-transform);--cosmos-asset-item-base-meta-text-primary-color:var(--cosmos-story-item-reading-time-color);--cosmos-asset-item-base-meta-text-primary-font-family:var(--cosmos-story-item-reading-time-font-family);--cosmos-asset-item-base-meta-text-primary-font-size:var(--cosmos-story-item-reading-time-font-size);--cosmos-asset-item-base-meta-text-primary-font-style:var(--cosmos-story-item-reading-time-font-style);--cosmos-asset-item-base-meta-text-primary-font-weight:var(--cosmos-story-item-reading-time-font-weight);--cosmos-asset-item-base-meta-text-primary-letter-spacing:var(--cosmos-story-item-reading-time-letter-spacing);--cosmos-asset-item-base-meta-text-primary-line-height:var(--cosmos-story-item-reading-time-line-height);--cosmos-asset-item-base-meta-text-primary-text-transform:var(--cosmos-story-item-reading-time-text-transform);--cosmos-asset-item-base-meta-text-additional-color:var(--cosmos-story-item-additional-info-color);--cosmos-asset-item-base-meta-text-additional-font-family:var(--cosmos-story-item-additional-info-font-family);--cosmos-asset-item-base-meta-text-additional-font-size:var(--cosmos-story-item-additional-info-font-size);--cosmos-asset-item-base-meta-text-additional-font-style:var(--cosmos-story-item-additional-info-font-style);--cosmos-asset-item-base-meta-text-additional-font-weight:var(--cosmos-story-item-additional-info-font-weight);--cosmos-asset-item-base-meta-text-additional-letter-spacing:var(--cosmos-story-item-additional-info-letter-spacing);--cosmos-asset-item-base-meta-text-additional-line-height:var(--cosmos-story-item-additional-info-line-height);--cosmos-asset-item-base-meta-text-additional-text-transform:var(--cosmos-story-item-additional-info-text-transform)}.cosmos-story-item__image{--cosmos-image-border-radius:var(--cosmos-story-item-image-radius, 4px);height:100%;width:100%}.cosmos-story-item__additional-info{display:-ms-flexbox;display:flex}.cosmos-story-item__additional-info ::slotted([slot=additional-info-prefix]){-webkit-margin-end:4px;margin-inline-end:4px}";
const CosmosStoryItemStyle0 = cosmosStoryItemCss;

const generateClassNames = bem('cosmos-story-item');
const CosmosStoryItem$1 = /*@__PURE__*/ proxyCustomElement(class CosmosStoryItem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.additionalInfo = undefined;
        this.appearance = undefined;
        this.headline = undefined;
        this.href = undefined;
        this.image = undefined;
        this.readingTime = undefined;
        this.rel = undefined;
        this.size = 'small';
        this.target = undefined;
    }
    getImageAppearance() {
        return this.appearance ? (this.appearance === 'dark' ? 'light' : 'dark') : undefined;
    }
    hasAdditionalInfoSot() {
        return hasNamedSlot(this.element, 'additional-info-prefix');
    }
    render() {
        return (h("cosmos-asset-item-base", { key: 'b96bd321a71cd76899591fc4cd6464283342f1e9', appearance: this.appearance, class: generateClassNames(), exportparts: "base: base, headline: headline, meta-text-primary: reading-time, additional-info: additional-info", headline: this.headline, headlineClamp: 2, href: this.href, metaTextPrimary: this.readingTime, metaTextPrimaryClamp: true, metaTextAdditional: this.additionalInfo, rel: this.rel, size: this.size, target: this.target }, h("cosmos-image", { key: '72a77ed0a74be0663f936610138dc39d3f4ee498', appearance: this.getImageAppearance(), class: generateClassNames('image'), exportparts: "base: image", image: this.image, imageAlt: "", slot: "image" }), this.hasAdditionalInfoSot() && (h("span", { "aria-hidden": "true", slot: "meta-text-additional-info-prefix", class: generateClassNames('additional-info') }, h("slot", { name: "additional-info-prefix" })))));
    }
    get element() { return this; }
    static get style() { return CosmosStoryItemStyle0; }
}, [1, "cosmos-story-item", {
        "additionalInfo": [513, "additional-info"],
        "appearance": [513],
        "headline": [513],
        "href": [513],
        "image": [513],
        "readingTime": [513, "reading-time"],
        "rel": [513],
        "size": [513],
        "target": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-story-item", "cosmos-asset-item-base", "cosmos-image", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-story-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosStoryItem$1);
            }
            break;
        case "cosmos-asset-item-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-image":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosStoryItem = CosmosStoryItem$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosStoryItem, defineCustomElement };
